import React from "react";
import { Row, Col, Divider, Card, Button } from "antd";
import IntlMessages from "../../../util/IntlMessages";
import _ from "lodash";
import {
  isEmptyObject,
  getDecryptID,
  formatDigits,
  customParse,
} from "../../../appRedux/actions/GlobalMethods";
import Barcode from "react-barcode";
const Dummy = (props) => {
  const { outletName, registerName, getIsTaxExclusive } = props;
  const decimal = props.decimal ? props.decimal : 2;
  const templateData = props.templateData ? props.templateData : false;
  const data = props.data ? props.data : false;
  const currData = props.currData
    ? props.currData
    : {
        currencyCode: "",
      };
  const objToday = new Date(),
    weekday = new Array(
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ),
    dayOfWeek = weekday[objToday.getDay()],
    domEnder = (function () {
      var a = objToday;
      if (/1/.test(parseInt((a + "").charAt(0)))) return "th";
      a = parseInt((a + "").charAt(1));
      return 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th";
    })(),
    dayOfMonth =
      today + (objToday.getDate() < 10)
        ? "0" + objToday.getDate() + domEnder
        : objToday.getDate() + domEnder,
    months = new Array(
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ),
    curMonth = months[objToday.getMonth()],
    curYear = objToday.getFullYear(),
    curHour =
      objToday.getHours() > 12
        ? objToday.getHours() - 12
        : objToday.getHours() < 10
        ? "0" + objToday.getHours()
        : objToday.getHours(),
    curMinute =
      objToday.getMinutes() < 10
        ? "0" + objToday.getMinutes()
        : objToday.getMinutes(),
    curSeconds =
      objToday.getSeconds() < 10
        ? "0" + objToday.getSeconds()
        : objToday.getSeconds(),
    curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";
  const today =
    dayOfMonth +
    " of " +
    curMonth +
    ", " +
    curYear +
    " " +
    dayOfWeek +
    " " +
    curHour +
    ":" +
    curMinute +
    "." +
    curSeconds +
    " " +
    curMeridiem;

  return (
    <>
      {templateData ? (
        <div className="custom-print-outer-layout">
          <div>
            <Row justify="center">
              <Col>
                {templateData.headImageURL && (
                  <>
                    <img src={templateData.headImageURL} alt="avatar" />
                  </>
                )}
              </Col>
            </Row>
            <Row justify="center">
              <Col>
                {templateData.headInfoHtml &&
                  !templateData.headInfoHtml.includes("null") && (
                    <div
                      className="reciept-font-size-danger"
                      dangerouslySetInnerHTML={{
                        __html: templateData.headInfoHtml,
                      }}
                    />
                  )}
              </Col>
            </Row>
            {outletName && outletName != "" && (
              <Row justify="center">
                <Col>
                  <h2 className="reciept-font-size">
                    <strong>{outletName}</strong>
                  </h2>
                </Col>
              </Row>
            )}
            {templateData.isDisplayServedBy && (
              <Row justify="center">
                <Col>
                  <h3 className="reciept-font-size">
                    <IntlMessages id="sell.thermalprint.servedby" />{" "}
                    {templateData.servedByLabel}{" "}
                    {`${data && data.soldBy ? data.soldBy : "User"}`} at{" "}
                    {registerName && registerName != "" && <>{registerName}</>}
                  </h3>
                </Col>
              </Row>
            )}

            {data && data.isRepeat && (
              <Row justify="center" style={{ marginTop: 6, marginBottom: 6 }}>
                <Col>
                  <h3 className="reciept-font-size">
                    <h3 className="reciept-font-size">{`* * * Reprint * * *`}</h3>
                  </h3>
                </Col>
              </Row>
            )}

            <Divider dashed={true} style={{ backgroundColor: "black" }} />

            <Row justify="center">
              <Col>
                {templateData.invoiceNoPrefix && (
                  <h3 className="reciept-font-size">{`${templateData.invoiceNoPrefix}`}</h3>
                )}
              </Col>
            </Row>

            {data.receipt && data.receipt != "" && (
              <Row justify="center">
                <Col>
                  {templateData.invoiceNoPrefix && (
                    <h3 className="reciept-font-size">
                      <strong>
                        {`Receipt: #${data.receipt} `}
                        {data.saleNature && data.saleNature != ""
                          ? `(${data.saleNature})`
                          : ""}
                        {data.isRefundSale ? `RETURN SALE` : ""}
                      </strong>
                    </h3>
                  )}
                </Col>
              </Row>
            )}

            <Row justify="center">
              <Col>
                {today && <h3 className="reciept-font-size">{today}</h3>}
              </Col>
            </Row>

            <Divider dashed={true} style={{ backgroundColor: "black" }} />

            {data &&
              data.products &&
              data.products.length > 0 &&
              data.products.map((e, key) => {
                return (
                  <>
                    <div key={key} style={{ marginTop: 10 }}>
                      <Row>
                        <Col span={12}>
                          {templateData.showSKU && (
                            <h3 className="reciept-font-size">
                              {"SKU: "}
                              {e.SKU ? e.SKU : ""}
                            </h3>
                          )}
                          {templateData.showProductName && (
                            <h3 className="reciept-font-size">
                              {e.productName
                                ? `${e.productName} ${
                                    e.quantity ? `(${e.quantity})` : ``
                                  }`
                                : ""}
                            </h3>
                          )}
                          {templateData.showProductNameAndSKU && (
                            <h3 className="reciept-font-size">
                              {e.productName
                                ? `${e.productName} ${
                                    e.quantity ? `(${e.quantity})` : ``
                                  }`
                                : ""}
                              {" / "}
                              {"SKU: "}
                              {e.SKU ? e.SKU : ""}
                            </h3>
                          )}{" "}
                        </Col>
                      </Row>

                      <Row>
                        <Col span={12} push={1}>
                          <h4 className="reciept-font-size">
                            {e.quantity ? e.quantity : ""}
                            {" @ "}
                            {e.totalPriceReceipt
                              ? `${currData.currencyCode} ${e.totalPriceReceipt}`
                              : ""}
                          </h4>
                        </Col>

                        <Col span={12}>
                          <h3
                            style={{ float: "right", marginRight: "2px" }}
                            className="reciept-font-size"
                          >
                            {e.totalPriceReceipt
                              ? `${currData.currencyCode} ${e.totalPriceReceipt}`
                              : ""}
                          </h3>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={12} push={1}>
                          {e.salesItemDiscount &&
                            customParse(e.salesItemDiscount) > 0 && (
                              <p
                                className="reciept-font-size"
                                style={{ marginTop: -8 }}
                              >
                                {`Was: ${currData.currencyCode} 
                                ${formatDigits(
                                  customParse(
                                    e.totalPriceReceipt / e.quantity
                                  ) + customParse(e.salesItemDiscount),
                                  decimal
                                )} 
                                Disc: ${e.discountPercentage}% /  ${
                                  currData.currencyCode
                                } ${formatDigits(
                                  e.salesItemDiscount,
                                  decimal
                                )}`}
                              </p>
                            )}
                          {e.promotions &&
                            !isEmptyObject(e.promotions) &&
                            e.promotions.promotionName &&
                            e.promotions.promotionName != "" && (
                              <span>
                                <p style={{ marginTop: -8 }}>
                                  {`Promotion: ${e.promotions.promotionName} (${
                                    e.promotionPercent
                                      ? `${e.promotionPercent}% / `
                                      : ""
                                  } ${
                                    currData.currencySymbol
                                      ? currData.currencySymbol
                                      : currData.currencyCode
                                      ? currData.currencyCode
                                      : ""
                                  }
                                    ${
                                      e.promotions.promotionValue
                                        ? formatDigits(
                                            e.promotions.promotionValue /
                                              e.quantity,
                                            decimal
                                          )
                                        : "0.00"
                                    } off)`}
                                </p>
                                {e.promotion &&
                                  e.promotion.promoCodes &&
                                  e.promotion.promoCodes.length > 0 &&
                                  e.promotion.promoCodes.map((ggf, iop) => {
                                    return (
                                      <p key={iop}>
                                        {`Applied Code: ${ggf.codeName}`}
                                      </p>
                                    );
                                  })}
                              </span>
                            )}
                          {e.priceBookValue &&
                            customParse(e.priceBookValue) > 0 && (
                              <p
                                className="reciept-font-size"
                                style={{ marginTop: -8 }}
                              >
                                {`Disc: (${
                                  e.priceBookPercent
                                    ? `${e.priceBookPercent}%  / `
                                    : ""
                                } ${
                                  currData.currencySymbol
                                    ? currData.currencySymbol
                                    : currData.currencyCode
                                    ? currData.currencyCode
                                    : ""
                                }${formatDigits(
                                  e.priceBookValue / e.quantity,
                                  decimal
                                )} off)`}
                              </p>
                            )}
                          {e.productNote && e.productNote != "" && (
                            <p
                              className="reciept-font-size"
                              style={{ fontSize: "small", marginTop: -10 }}
                            >
                              <IntlMessages id="sell.sell.note" />
                              {` ${e.productNote}`}
                            </p>
                          )}
                        </Col>

                        <Col span={12}>
                          <h3
                            className="reciept-font-size"
                            style={{
                              float: "right",
                              marginRight: "2px",
                              textDecoration: "line-through",
                            }}
                          >
                            {e.salesItemDiscount &&
                            customParse(e.salesItemDiscount) > 0
                              ? `${currData.currencyCode} 
                                ${formatDigits(
                                  customParse(e.totalPriceReceipt) +
                                    customParse(
                                      e.salesItemDiscount * e.quantity
                                    ),
                                  decimal
                                )}`
                              : ""}
                          </h3>
                        </Col>
                      </Row>

                      {templateData.showTaxPerLineItem &&
                        data &&
                        data.taxes &&
                        data.taxes.length > 0 &&
                        data.taxes
                          .filter((a) => a.itemIdentifyID == e.itemIdentifyID)
                          .map((b, key) => {
                            return (
                              <Row key={key}>
                                <Col span={24} push={1}>
                                  <h3 className="reciept-font-size">
                                    {`${b.saleTaxName} (${b.taxValue}% / ${currData.currencyCode} ${b.taxPrice})`}
                                  </h3>
                                </Col>
                              </Row>
                            );
                          })}
                    </div>
                  </>
                );
              })}

            <Divider dashed={true} style={{ backgroundColor: "black" }} />

            <Row>
              <Col span={12} push={2}>
                <h3 className="reciept-font-size">
                  <strong>
                    {templateData.subTotalLabel ? (
                      templateData.subTotalLabel
                    ) : (
                      <IntlMessages id="sell.thermalprint.Subtotal" />
                    )}
                  </strong>
                </h3>
              </Col>

              <Col span={12}>
                <h3
                  className="reciept-font-size"
                  style={{ float: "right", marginRight: "2px" }}
                >
                  <strong>
                    {data && data.totalPrice
                      ? `${currData.currencyCode} 
                        ${formatDigits(
                          customParse(data.totalPrice) +
                            (data.additionalDiscount &&
                            data.additionalDiscount != "0.00"
                              ? customParse(data.additionalDiscount)
                              : 0) -
                            customParse(data.totalTax),
                          decimal
                        )}`
                      : "0.00"}
                  </strong>
                </h3>
              </Col>
            </Row>

            {data.additionalDiscount && data.additionalDiscount != "" && (
              <Row>
                <Col span={12} push={2}>
                  <h3 className="reciept-font-size">
                    <IntlMessages id="sell.salehistory.adddis" />
                  </h3>
                </Col>

                <Col span={12}>
                  <h3
                    className="reciept-font-size"
                    style={{ float: "right", marginRight: "2px" }}
                  >
                    {`${currData.currencyCode} ${data.additionalDiscount}`}
                  </h3>
                </Col>
              </Row>
            )}

            {templateData.showTaxTotals && (
              <>
                <Row>
                  <Col span={12} push={2}>
                    <h3 className="reciept-font-size">
                      <strong>
                        {templateData.taxTotalLabel ? (
                          `${templateData.taxTotalLabel} ${
                            data && data.taxesSum && data.taxesSum.length > 0
                              ? ` (${data.taxesSum.length} Taxes)`
                              : ``
                          }`
                        ) : (
                          <IntlMessages id="sell.thermalprint.totltax" />
                        )}
                      </strong>
                    </h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      className="reciept-font-size"
                      style={{ float: "right", marginRight: "2px" }}
                    >
                      <strong>
                        {data && data.totalTax
                          ? `${currData.currencyCode} ${data.totalTax}`
                          : "0.00"}
                      </strong>
                    </h3>
                  </Col>
                </Row>

                {data && data.taxesSum && data.taxesSum.length > 0 ? (
                  data.taxesSum.map((e, key) => {
                    return (
                      <Row key={key}>
                        <Col span={12} push={3}>
                          <h4 className="reciept-font-size">
                            {e.saleTaxName
                              ? `${e.saleTaxName}   (${e.taxValue}%)`
                              : ""}
                          </h4>
                        </Col>

                        <Col span={12}>
                          <h3
                            style={{ float: "right", marginRight: "2px" }}
                            className="reciept-font-size"
                          >
                            {e.taxPrice
                              ? `${currData.currencyCode} ${e.taxPrice}`
                              : ""}
                          </h3>
                        </Col>
                      </Row>
                    );
                  })
                ) : (
                  <Row>
                    <Col span={24} push={2}>
                      <h3
                        className="reciept-font-size"
                        style={{ marginLeft: "10px" }}
                      >
                        <IntlMessages id="sell.salehistory.notax" />
                      </h3>
                    </Col>
                  </Row>
                )}

                {/* {data && data.taxes && data.taxes.length > 0 ? (
                    _.uniqBy(data.taxes, "saleTaxName").map((d, key) => {
                      return (
                        <>
                          <Row key={key}>
                            <Col span={12} push={2}>
                              <h3 style={{ marginLeft: "10px" }}>
                                {d.saleTaxName
                                  ? `${d.saleTaxName} ${d.taxValue ? ` (${d.taxValue}%)` : ``
                                  }`
                                  : ""}
                              </h3>
                            </Col>
      
                            <Col span={12}>
                              <h3
                                style={{ float: "right", marginRight: "2px" }}
                              >
                                {d.taxPrice
                                  ? `${currData.currencyCode} ${d.taxPrice}`
                                  : ""}
                              </h3>
                            </Col>
                          </Row>
                        </>
                      );
                    })
                  ) : (
                    <Row>
                      <Col span={24} push={2}>
                        <h3 style={{ marginLeft: "10px" }}>
                          <IntlMessages id="sell.salehistory.notax" />
                        </h3>
                      </Col>
                    </Row>
                  )} */}
              </>
            )}

            <Divider style={{ backgroundColor: "black" }} />

            <Row>
              <Col span={12}>
                <h3 className="reciept-font-size">
                  <strong>
                    {templateData.totalLabel ? (
                      `${templateData.totalLabel} ${
                        data && data.totalItems && data.totalItems > 0
                          ? ` (${data.totalItems} items)`
                          : ``
                      }`
                    ) : (
                      <IntlMessages id="sell.thermalprint.totl" />
                    )}
                  </strong>
                </h3>
              </Col>

              <Col span={12}>
                <h3
                  className="reciept-font-size"
                  style={{ float: "right", marginRight: "2px" }}
                >
                  <strong>
                    {data && data.totalPrice
                      ? `${currData.currencyCode} ${data.totalPrice}`
                      : ""}
                  </strong>
                </h3>
              </Col>
            </Row>

            <Divider style={{ backgroundColor: "black" }} />

            {data && data.payments && data.payments.length > 0 && (
              <Row style={{ marginBottom: 10 }}>
                <Col span={24}>
                  <p className="reciept-font-size">
                    <strong>
                      <IntlMessages id="sell.thermalprint.paymentsthrough" />
                    </strong>
                  </p>
                </Col>
              </Row>
            )}

            {data &&
              data.payments &&
              data.payments.length > 0 &&
              data.payments.map((pay, key) => {
                return (
                  <Row key={key}>
                    <Col span={8}>
                      <h3 className="reciept-font-size">
                        {pay.paymentName ? pay.paymentName : ""}
                      </h3>
                    </Col>

                    <Col span={10}>
                      <h3 className="reciept-font-size">
                        {pay.paymentOn ? pay.paymentOn : ""}
                      </h3>
                    </Col>

                    <Col span={6}>
                      <h3
                        className="reciept-font-size"
                        style={{ float: "right" }}
                      >
                        {pay.amount
                          ? `${currData.currencyCode} ${pay.amount}`
                          : ""}
                      </h3>
                    </Col>
                  </Row>
                );
              })}

            <Row>
              <Col span={12} push={2}>
                <Divider style={{ backgroundColor: "black" }} />
                <h3 className="reciept-font-size">
                  {templateData.toPayLabel ? (
                    templateData.toPayLabel
                  ) : (
                    <IntlMessages id="sell.thermalprint.topay" />
                  )}
                </h3>
              </Col>

              <Col span={12}>
                <Divider style={{ backgroundColor: "black" }} />
                <h3
                  className="reciept-font-size"
                  style={{ float: "right", marginRight: "2px" }}
                >
                  {data.toPay && data.toPay != ""
                    ? `${currData.currencyCode} ${data.toPay}`
                    : "0.00"}
                </h3>
              </Col>
            </Row>

            {data.change && customParse(data.change) > 0 && (
              <Row>
                <Col span={12} push={2}>
                  <h3 className="reciept-font-size">
                    {templateData.changeLabel ? (
                      templateData.changeLabel
                    ) : (
                      <IntlMessages id="sell.thermalprint.change" />
                    )}
                  </h3>
                </Col>

                <Col span={12}>
                  <h3
                    className="reciept-font-size"
                    style={{ float: "right", marginRight: "2px" }}
                  >
                    {data && data.change
                      ? `${currData.currencyCode} ${data.change}`
                      : "0.00"}
                  </h3>
                </Col>
              </Row>
            )}

            <Divider style={{ backgroundColor: "black" }} />

            {data.totalSavings && customParse(data.totalSavings) > 0 && (
              <>
                <Row>
                  <Col span={12}>
                    <h3 className="reciept-font-size">
                      <strong>
                        <IntlMessages id="sell.thermalprint.totalsavings" />
                      </strong>
                    </h3>
                  </Col>

                  <Col span={12}>
                    <h3
                      className="reciept-font-size"
                      style={{ float: "right", marginRight: "2px" }}
                    >
                      <strong>
                        {`${currData.currencyCode} ${data.totalSavings}`}
                      </strong>
                    </h3>
                  </Col>
                </Row>
                <Divider style={{ backgroundColor: "black" }} />
              </>
            )}

            {data &&
              (data.customerEmail ||
                data.customerPhone ||
                data.customerAddress ||
                data.customerGroupName ||
                data.firstName ||
                data.lastName) &&
              templateData.showCustomerDetails && (
                <>
                  <Row justify="center">
                    <Col>
                      <h2 className="reciept-font-size">
                        <strong>
                          <IntlMessages id="sell.thermalprint.customers" />
                        </strong>
                      </h2>
                    </Col>
                  </Row>
                  <div>
                    {data.customerGroupName &&
                      templateData.showCustomerCompany && (
                        <Row>
                          <Col span={4}>
                            <h3 className="reciept-font-size">
                              <strong>
                                <IntlMessages id="sell.thermalprint.groupname" />
                              </strong>
                            </h3>
                          </Col>

                          <Col span={20}>
                            <h3 className="reciept-font-size">
                              {data.customerGroupName}
                            </h3>
                          </Col>
                        </Row>
                      )}
                    {(data.firstName || data.lastName) &&
                      templateData.showCustomerName && (
                        <Row>
                          <Col span={4}>
                            <h3 className="reciept-font-size">
                              <strong>
                                <IntlMessages id="sell.thermalprint.cusname" />
                              </strong>
                            </h3>
                          </Col>

                          <Col span={20}>
                            <h3 className="reciept-font-size">
                              {data.firstName + " " + data.lastName}
                            </h3>
                          </Col>
                        </Row>
                      )}
                    {data.customerCode && templateData.showCustomerCode && (
                      <Row>
                        <Col span={4}>
                          <h3 className="reciept-font-size">
                            <strong>
                              <IntlMessages id="sell.thermalprint.cuscode" />
                            </strong>
                          </h3>
                        </Col>

                        <Col span={20}>
                          <h3 className="reciept-font-size">
                            {data.customerCode}
                          </h3>
                        </Col>
                      </Row>
                    )}
                    {data.customerEmail && templateData.showCustomerEmail && (
                      <Row>
                        <Col span={4}>
                          <h3 className="reciept-font-size">
                            <strong>
                              <IntlMessages id="sell.thermalprint.cusemail" />
                            </strong>
                          </h3>
                        </Col>

                        <Col span={20}>
                          <h3 className="reciept-font-size">
                            {data.customerEmail}
                          </h3>
                        </Col>
                      </Row>
                    )}
                    {data.customerPhone && templateData.showCustomerPhone && (
                      <Row>
                        <Col span={4}>
                          <h3 className="reciept-font-size">
                            <strong>
                              <IntlMessages id="sell.thermalprint.cusphone" />
                            </strong>
                          </h3>
                        </Col>

                        <Col span={20}>
                          <h3 className="reciept-font-size">
                            {data.customerPhone}
                          </h3>
                        </Col>
                      </Row>
                    )}
                    {data.customerAddress && templateData.showCustomerAddress && (
                      <Row>
                        <Col span={4}>
                          <h3 className="reciept-font-size">
                            <strong>
                              <IntlMessages id="sell.thermalprint.cusaddress" />
                            </strong>
                          </h3>
                        </Col>

                        <Col span={20}>
                          <h3 className="reciept-font-size">
                            {data.customerAddress}
                          </h3>
                        </Col>
                      </Row>
                    )}
                    <Divider style={{ backgroundColor: "black" }} />
                  </div>
                </>
              )}

            <Row justify="center">
              <h3 className="reciept-font-size">
                {templateData.loyaltyMessage
                  ? templateData.loyaltyMessage
                  : `Register your details with ${
                      data && data.storeName ? data.storeName : "us"
                    } for Loyalty Program:`}
              </h3>
            </Row>

            <Row justify="center" style={{ display : "flex", flexDirection :"column" ,marginTop: 10 }} >
              <h2 className="reciept-font-size">
                {templateData.footerHtml &&
                !templateData.footerHtml.includes("null") ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: templateData.footerHtml,
                    }}
                  />
                ) : (
                  <IntlMessages id="sell.thermalprint.goodbye" />
                )}
              </h2>
             
            </Row>
            {data.receipt && data.receipt != "" && (
                <Row justify="center">
                  <Col>
                  <Barcode
                      value={data.receipt}
                      width={3}
            
                      textAlign={"center"}
                      fontSize={15}
                      displayValue={false}
                      marginBottom={0}
                    />
                  </Col>
                </Row>
              )}
          </div>
        </div>
      ) : (
        <h1>
          <IntlMessages id="sell.openclose.connectionlost" />
        </h1>
      )}
    </>
  );
};

export default Dummy;
